export type GeneralInformationsData = {
  stationName: string;
  frequency: string;
  radioType: {
    commercial: boolean;
    community: boolean;
    musical: boolean;
    ethnic: boolean;
    talk: boolean;
  };
  address: string;
  city: string;
  zipCode: string;
  website: string;
};

export type TechnologyDirectorData = {
  name: string;
  phone: string;
  email: string;
};

export type WebAgencyData = {
  webAgencyName: string;
  webAgencyDirector: string;
  webAgencyPhone: string;
  webAgencyEmail: string;
};

export type CurrentStreamAndEquipmentData = {
  bitrate: string;
  averageSimultaneousUsers: string;
};

export type WebPlayerData = {
  hasWebPlayer: boolean;
  webPlayerShowsPlayingSongs: boolean;
};

export type RadioInformationFormSection = GeneralInformationsData | TechnologyDirectorData | WebAgencyData | WebPlayerData;

export type RadioInformationFormData = {
  generalInformations: GeneralInformationsData;
  technologyDirector: TechnologyDirectorData;
  webAgency: WebAgencyData;
  webPlayer: WebPlayerData;
};

export const INITIAL_DATA: RadioInformationFormData = {
  generalInformations: {
    stationName: '',
    frequency: '',
    radioType: {
      commercial: false,
      community: false,
      musical: false,
      ethnic: false,
      talk: false,
    },
    address: '',
    city: '',
    zipCode: '',
    website: '',
  },

  technologyDirector: {
    name: '',
    phone: '',
    email: '',
  },

  webAgency: {
    webAgencyName: '',
    webAgencyDirector: '',
    webAgencyPhone: '',
    webAgencyEmail: '',
  },

  webPlayer: {
    hasWebPlayer: false,
    webPlayerShowsPlayingSongs: false,
  },
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/domain/RadioInformationForm.js